import React, { FC } from 'react';
import viewClaims1 from '../../../assets/help/viewClaims/view_claims_1.png';
import viewClaims2 from '../../../assets/help/viewClaims/view_claims_2.png';
import viewClaims3 from '../../../assets/help/viewClaims/view_claims_3.png';
import viewClaims4 from '../../../assets/help/viewClaims/view_claims_4.png';
import viewClaims5 from '../../../assets/help/viewClaims/view_claims_5.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpAlert, HelpBody, HelpBullet, HelpImage, HelpIndent, HelpStep, HelpTitle } from './HelpElements';

const ViewClaimsHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('viewClaimsHelp');

    return (
        <>
            <HelpTitle>{t('viewClaimsHelp_Title')}</HelpTitle>
            <HelpBody>{t('viewClaimsHelp_purpose')}</HelpBody>
            <HelpStep step={1}>{t('viewClaimsHelp_step1')}</HelpStep>
            <HelpImage size={'xlarge'} src={viewClaims1} />
            <HelpStep step={2}>{t('viewClaimsHelp_step2')}</HelpStep>
            <HelpImage size={'xlarge'} src={viewClaims2} />
            <HelpAlert>{t('viewClaimsHelp_step2_support_documents')}</HelpAlert>
            <HelpImage size={'xlarge'} src={viewClaims3} />
            <HelpStep step={3}>{t('viewClaimsHelp_step3_intro')}</HelpStep>
            <HelpIndent>
                <HelpBullet>{t('viewClaimsHelp_status_created')}</HelpBullet>
                <HelpBullet>{t('viewClaimsHelp_status_inProgress')}</HelpBullet>
                <HelpBullet>{t('viewClaimsHelp_status_error')}</HelpBullet>
                <HelpImage src={viewClaims4} />
            </HelpIndent>
            <HelpStep step={4}>{t('viewClaimsHelp_step4_intro')}</HelpStep>
            <HelpIndent>
                <HelpBullet>{t('viewClaimsHelp_creditMemo_notAvailable')}</HelpBullet>
                <HelpBullet>{t('viewClaimsHelp_creditMemo_notProcessed')}</HelpBullet>
                <HelpBullet>{t('viewClaimsHelp_creditMemo_processing')}</HelpBullet>
                <HelpBullet>{t('viewClaimsHelp_creditMemo_completed')}</HelpBullet>
            </HelpIndent>
            <HelpStep step={5}>{t('viewClaimsHelp_step5')}</HelpStep>
            <HelpImage size={'xlarge'} src={viewClaims5} />
        </>
    );
};

export { ViewClaimsHelp };
